module.exports = __webpack_public_path__ + "img/traffic6.f40ee03e.png";